import { createContext, useState, useContext } from "react";

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {

    const [modals, setModals] = useState({}); // Store modals as { modalName: { isOpen: true, props: {} } }

    const openModal = (modalName, modalProps = {}) => {
        setModals((prev) => ({
            ...prev,
            [modalName]: { isOpen: true, props: modalProps },
        }));
        document.body.style.overflow = "hidden"; // Prevent body scroll when modal is open
    };

    const closeModal = (modalName) => {
        setModals((prev) => ({
            ...prev,
            [modalName]: { isOpen: false, props: {} }, // Clear props on close
        }));
        document.body.style.overflow = "auto"; // Prevent body scroll when modal is open
    };

    const isModalOpen = (modalName) => !!modals[modalName]?.isOpen;
    const getModalProps = (modalName) => modals[modalName]?.props || {};

    return (
        <ModalContext.Provider value={{ openModal, closeModal, isModalOpen, getModalProps }}>
            {children}
        </ModalContext.Provider>
    );
};

export const useModal = () => useContext(ModalContext);